import {useQuery, UseQueryOptions} from '@tanstack/react-query';

import {getPaymentCurrencies} from '../api';
import {QUERY__PAYMENT_CURRENCIES} from '../queryKeys';

export const useGetPaymentCurrencies = (
  options?: Omit<UseQueryOptions<string[]>, 'queryKey' | 'queryFn'>,
) =>
  useQuery({
    queryKey: [QUERY__PAYMENT_CURRENCIES],
    queryFn: getPaymentCurrencies,
    ...options,
  });
